var _text, _text2, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigiTmgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 80",
    width: 200,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#FF6B35"
  }, "360")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fill: "#333333"
  }, "DigiTMG")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 60,
    r: 3,
    fill: "#FF6B35"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 60,
    r: 3,
    fill: "#FF6B35"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 60,
    r: 3,
    fill: "#FF6B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigiTmgLogo);
export default __webpack_public_path__ + "static/media/digiTMGLogo.c82ddd5f92e7b7870c354a1e2425a4d7.svg";
export { ForwardRef as ReactComponent };